<template src="./ListInvoices.html"></template>

<script>
import { required } from 'vuelidate/lib/validators'
import { getInvoices, deleteInvoice, getInvoiceProcess } from '../../../services'
import { formatDateUTC } from '../../../utils/computeds'
import { OnlyAdmin } from '../../../utils/roles'
import { mapGetters } from 'vuex'
import Companies from '../../../components/Forms/Companies/Companies'

export default {
  name: 'Invoice',
  components: { Companies },
  data: () => ({
    menuFrom: false,
    menuTo: false,
    disabled: false,
    skip: 0,
    take: 50,
    search: {
      number: null,
      evaluatedDocument: null,
      companyId: null,
      dateFrom: '',
      dateTo: ''
    },
    invoice: { number: null },
    invoices: [],
    processes: [],
    processesModal: false
  }),
  validations () {
    return {
      invoice: {
        date: { required },
        number: { required },
        total: { required }
      }
    }
  },
  created () {
    this.searchInvoices()
  },
  methods: {
    async searchInvoices (add) {
      try {
        const params = {
          skip: this.skip,
          take: this.take
        }
        if (this.search.number) params.number = this.search.number
        if (this.search.evaluatedDocument) params.evaluatedDocument = this.search.evaluatedDocument
        if (this.search.companyId) params.companyId = this.search.companyId
        if (this.search.dateFrom) params.dateFrom = this.search.dateFrom
        if (this.search.dateTo) params.dateTo = this.search.dateTo

        const invoices = await getInvoices(params)

        if (!add) this.invoices = invoices
        else this.invoices.push(...invoices)

        this.disabled = invoices.length < this.take
      } catch (error) {
        console.log('Error on get invoices =>', error)
      }
    },
    onSearch () {
      this.skip = 0
      this.searchInvoices()
    },
    async more () {
      this.skip += this.take
      await this.searchInvoices(true)
    },
    async listProcesses (invoice) {
      this.invoice = invoice
      this.processes = await getInvoiceProcess(invoice.id)
      this.processesModal = true
    },
    ifDeleteInvoice (invoiceId) {
      this.$swal({
        title: '¿Está seguro de eliminar la factura?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((value) => {
        if (value) {
          this.removeInvoice(invoiceId)
        }
      })
    },
    async removeInvoice (invoiceId) {
      try {
        await deleteInvoice(invoiceId)
        this.$swal({
          text: 'Se elimino la factura.',
          buttons: false,
          icon: 'success',
          timer: 3000
        })
        this.onSearch()
      } catch (error) {
        console.log('Error on delete invoice =>', error)
        this.$swal({
          text: error.message ?? 'Ocurrio un error, intenta mas tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    }
  },
  computed: {
    formatDateUTC,
    OnlyAdmin,
    ...mapGetters({
      user: 'getUser'
    })
  }
}
</script>
